import { useValidations } from "@sttedra_ui/framework";

import { searchValue } from "@/composables/_commons/helper.js";
import { categoriesListAll } from "@/api/categories/categories.api.js";

const { required } = useValidations();

let categories;

// Get the data for the dropdowns
async function getCategories() {
  categories = await categoriesListAll();
}

export { getCategories, categories };

export default function (object = null, setURLInforme) {
  return {
    items: [
      {
        field: "titulo",
        label: "Título",
        value: searchValue(object, "titulo"),
        rules: { required },
        classObj: ["col-12"],
      },
      {
        field: "urlInforme",
        label: "URL del informe",
        value: searchValue(object, "urlInforme"),
        classObj: ["col-12 md:col-6 flex gap-2 align-items-center"],
        properties: {
          disabled: true,
        },
      },
      {
        field: "alias",
        label: "Alias del informe",
        value: searchValue(object, "alias"),
        rules: { required },
        classObj: ["col-12 md:col-6"],
        events: {
          input: () => setURLInforme(),
        },
      },
      {
        field: "aliasCategoria",
        label: "Categoría",
        value: searchValue(object, "categoria"),
        rules: { required },
        type: "Dropdown",
        properties: {
          options: categories,
          optionValue: "aliasCategoria",
          optionLabel: "titulo",
        },
        classObj: ["col-12 md:col-8"],
      },
      {
        field: "addCategory",
        classObj: ["col-12 md:col-4 custom-content"],
      },
      {
        field: "descripcion",
        label: "Descripción",
        value: searchValue(object, "descripcion"),
        type: "textarea",
        classObj: ["col-12"],
      },
      {
        field: "tieneCabecera",
        label: "Mostrar cabecera",
        value: searchValue(object, "tieneCabecera"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "comentable",
        label: "Colaboración habilitada",
        value: searchValue(object, "comentable"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "",
        classObj: ["hidden md:block col-4 empty-space"],
      },
      {
        field: "habilitado",
        label: "Informe habilitado",
        value: object == null ? true : searchValue(object, "habilitado"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "habilitadoDesde",
        label: "Habilitado desde",
        value: searchValue(object, "habilitadoDesde"),
        type: "calendar",
        properties: {
          showTime: true,
          manualInput: false,
        },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "",
        classObj: ["hidden md:block col-4 empty-space"],
      },
      {
        field: "esPublico",
        label: "Informe público",
        value: searchValue(object, "esPublico"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
        events: {
          input: () => setURLInforme(),
        },
      },
      {
        field: "publicoDesde",
        label: "Público desde",
        type: "calendar",
        properties: {
          showTime: true,
          disabled: true,
          manualInput: false,
        },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "publicoHasta",
        label: "Público hasta",
        type: "calendar",
        properties: {
          showTime: true,
          disabled: true,
          manualInput: false,
        },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "visible",
        label: "Informe visible",
        value: object == null ? true : searchValue(object, "visible"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "publicoPrivado",
        label: "Acceso para internos",
        value: searchValue(object, "publicoPrivado"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
      },
    ],
  };
}
